import axios from 'axios';
import {V1API} from "../../../_helpers/APIPath";
import {encode, decode} from "../../dataMagic";
import {populateStore, performNetworkCall, buildFormData} from "@/store/asyncHelper";

const keyList = {
    smsUpdate : 'TEAM_UPDATE',
    smsDelete : 'TEAM_DELETE'
};

const mutations = {};
const store = {};

populateStore(store, mutations, keyList, false);

export default {
    namespaced: true,

    state : {
        team: [],
        // team_log_count: null,
        // team_detail: {},

        submitSuccess: false,
        teamLoading: false,
        teamError: false,
        teamDetailLoading: false,
        teamDetailError: false,

        ...store
    },

    mutations : {
        ...mutations,

        SET_TEAM(state, results) {
            state.team = results;
        },

        // SET_TEAM_DETAILS(state, team) {
        //     state.team_detail = team;
        // },

        SUBMIT_SUCCESS (state, success) {
            state.submitSuccess = success;
        },

        TEAM_LOADING (state, loading) {
            state.teamLoading = loading;
        },

        TEAM_ERROR (state, hasError) {
            state.teamError = hasError;
        },

        // TEAM_DETAILS_LOADING (state, loading) {
        //     state.teamDetailLoading = loading;
        // },

        // TEAM_DETAILS_ERROR (state, hasError) {
        //     state.teamDetailError = hasError;
        // }
    },

    actions: {
        async addTeam ({commit, dispatch}, payload) {
            commit('TEAM_LOADING', true);
            commit('TEAM_ERROR', false);

            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token")
                }
            };

            try {
                let response = await axios.post(V1API.create_team, payload.team, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchTeam')
                return response

            } catch (e) {
                commit('TEAM_ERROR', true);
            } finally {
                commit('TEAM_LOADING', false);
            }
        },

        async fetchTeam ({ commit }) {
            commit('TEAM_LOADING', true);
            commit('TEAM_ERROR', false);

            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token")
                }
            };

            try {
                let result = await axios.get(V1API.team_list, config);
                let response = result.data.data
                commit('SET_TEAM', response);
                return result
            } catch(error) {
                commit('TEAM_ERROR', true);
            } finally {
                commit('TEAM_LOADING', false);
            }
        },

        // async fetchTeamDetails ({ commit }, payload) {
        //     commit('TEAM_DETAILS_LOADING', true);
        //     commit('TEAM_DETAILS_ERROR', false);

        //     let config = {
        //         headers: {
        //             Authorization: "Bearer " + localStorage.getItem("access_token")
        //         }
        //     };

        //     try {
        //         let result = await axios.get(V1API.team_details + payload, config);
        //         let response = result.data
        //         commit('SET_TEAM_DETAILS', response.data);
        //         return response

        //     } catch(error) {
        //         commit('TEAM_DETAILS_ERROR', true);
        //     } finally {
        //         commit('TEAM_DETAILS_LOADING', false);
        //     }
        // },

        async updateTeam ({commit, dispatch}, payload) {
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token")
                }
            };

            try {
                let response = await axios.patch(V1API.update_team + payload.id, payload.team, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchTeam')
                return response

            } catch (e) {
                commit('TEAM_ERROR', true);
            } finally {
                commit('TEAM_LOADING', false);
            }
        },

        async deleteTeam({commit, dispatch}, payload) {
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token")
                }
            };

            let response = await axios.delete(V1API.delete_team + payload.delete, config).then(result=>{
                let data = result.data
                return data
            })
            
            dispatch ('fetchTeam')
            return response
        },

        async updateSerial ({commit, dispatch}, payload) {
            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            let response = await axios.get(V1API.update_team_serial + payload.id + '/' + payload.serial, config).then(result => {
                let items = result.data
                // dispatch('getProjectList')
                return result
            })
            return response
        }
    },

    getters: {}
}
